import http from "@http"
//获取菜单树
export function getMenuTree(data) {
    return http({
        url: '/lskj-admin/api/admin/menu/tree',
        method: "post",
        data
    })
}
//菜单列表  分页
export function getMenuList(data) {
    return http({
        url: '/lskj-admin/api/admin/menu/list',
        method: "post",
        data
    })
}
export function getMenuAll(data) {
    return http({
        url: '/lskj-admin/api/admin/menu/all',
        method: "post",
        data
    })
}

//查询单条菜单信息
export function menuById(data) {
    return http({
        url: `/lskj-admin/api/admin/menu/byId?id=${data.id}`,
        method: "get",
    })
}

//添加菜单
export function menuAdd(data) {
    return http({
        url: '/lskj-admin/api/admin/menu/add',
        method: "post",
        data
    })
}

//修改菜单信息
export function updeteMenu(data) {
    return http({
        url: `/lskj-admin/api/admin/menu`,
        method: "put",
        data
    })
}
//删除菜单信息
export function deleteMenu(data) {
    return http({
        url: `/lskj-admin/api/admin/menu?ids=${data.ids}`,
        method: "delete",
        data
    })
}